export function debounce(func: Function, wait: number | undefined, immediate?: boolean) {
  var timeout: string | number | NodeJS.Timeout | null
  return function () {
    var context = this,
      args = arguments
    clearTimeout(Number(timeout))
    if (immediate && !timeout) func.apply(context, args)
    timeout = setTimeout(function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }, wait)
  }
}
